export interface NodeHealthRateInput {
  nodeId: number;
  healthStatus?: string | null;
}

const FAILURE_RATE_THRESHOLD_PERCENT = 20;

export function toFailurePercent(rate?: number): number {
  const normalized = Number(rate);
  if (!Number.isFinite(normalized)) return 0;
  return normalized <= 1 ? normalized * 100 : normalized;
}

/**
 * 節點健康率以 Dashboard 顯示的全部節點為分母。
 *
 * 只有 healthStatus=healthy 且最近連線失敗率低於 20% 才算健康；
 * down、unknown、degraded、其他未識別狀態，以及失敗率達門檻的節點
 * 都算不健康。沒有節點時回 0，避免以 100% 呈現「沒有資料」。
 */
export function calculateNodeHealthRate(
  nodes: readonly NodeHealthRateInput[],
  failureRatePercentByNode: Readonly<Record<number, number>>,
): number {
  if (nodes.length === 0) return 0;

  let healthyCount = 0;
  for (const node of nodes) {
    if (node.healthStatus !== 'healthy') continue;

    const failureRatePercent = failureRatePercentByNode[node.nodeId] ?? 0;
    if (failureRatePercent < FAILURE_RATE_THRESHOLD_PERCENT) {
      healthyCount++;
    }
  }

  return Math.round((healthyCount / nodes.length) * 100);
}
